import { lazy, Suspense, useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import "./styles/classes.scss";
import "./styles/variables.scss";
import "./styles/styles.scss";
import "./App.css";
import { clientRoutes } from "./utils/routes";
import { AuthHelpers } from "./utils/auth.helpers";
import { LocalStorageHelpers } from "./utils/helpers/localstorage.helpers";
import { CommonEnums } from "./enums/common.enums";
import { AgentApi } from "./utils/api/Agent";
import { AgencyApi } from "./utils/api/Agency";
import { agentApproved } from "./utils/helpers/common";
import AnnouncementPostList from "./pages/dashboard/workspace/announcementpost/list/AnnouncementPostList";
import CreateAnnouncementPost from "./pages/dashboard/workspace/announcementpost/CreateAnnouncementPost";
import AnnouncementPostView from "./pages/dashboard/workspace/announcementpost/view/AnnouncementPostView";
import CoAgentPropertyPostView from "./pages/dashboard/workspace/propertypost/view/CoAgentPropertyPostView";
import CoAgentPropertyView from "./pages/dashboard/workspace/agentPropertyPost/view/CoAgentPropertyPostView";
import AnnouncementTypes from "./pages/dashboard/designTemplates/designTemplateTypes/AnnouncementTypes";
import AgencyCreateAnnouncementPost from "./pages/dashboard/workspace/agencyannouncementpost/CreateAnnouncementPost";
import AgencyAnnouncementPostView from "./pages/dashboard/workspace/agencyannouncementpost/view/AnnouncementPostView";
import AgencyAnnouncementPostList from "./pages/dashboard/workspace/agencyannouncementpost/list/AnnouncementPostList";
import FestivalTypes from "./pages/dashboard/designTemplates/designTemplateTypes/FestivalTemplateTypes/FestivalTypes";
import CreateFestivalPost from "./pages/dashboard/workspace/festivalPost/CreateFestivalPost";
import FestivalPostView from "./pages/dashboard/workspace/festivalPost/view/FestivalPostView";
import FestivalPostList from "./pages/dashboard/workspace/festivalPost/list/FestivalPostList";
import AgencyCreateFestivalPost from "./pages/dashboard/workspace/agencyfestivalpost/CreateFestivalPost";
import AgencyFestivalPostView from "./pages/dashboard/workspace/agencyfestivalpost/view/FestivalPostView";
import AgencyFestivalPostList from "./pages/dashboard/workspace/agencyfestivalpost/list/FestivalPostList";
import AgencyOnboardingPostView from "./pages/dashboard/workspace/agencyonboardingpost/view/AgencyOnboardingPostView";
import AgencyOnboardingPostList from "./pages/dashboard/workspace/agencyonboardingpost/list/AgencyOnboardingPostList";
import AgencyCreateOnBoardingPost from "./pages/dashboard/workspace/agencyonboardingpost/AgencyCreateOnBoardingPost";
// import Subscription from "./pages/dashboard/subscriptions/Subscription";
// import Subscription from "./pages/dashboard/subscriptions/subscription";
// import PropertyPostView from "./pages/dashboard/workspace/propertypost/view/PropertyPostView";
/**
 * Lazy load page components
 */

const ManageInvitesList = lazy(() => import("./pages/dashboard/manageInvite"));
const InvitationDetails = lazy(
  () => import("./pages/dashboard/manageInvite/view")
);
const Properties = lazy(() => import("./pages/dashboard/properties"));
const PropertieEdit = lazy(() => import("./pages/dashboard/properties/edit"));
const AgentProfileView = lazy(
  () => import("./pages/dashboard/profile/agentProfile")
);
const AgencyProfileView = lazy(
  () => import("./pages/dashboard/profile/agencyProfile")
);

const Workspace = lazy(() => import("./pages/dashboard/workspace"));
const Subscription = lazy(
  () => import("./pages/dashboard/subscriptions/Subscription")
);

const PropertyPost = lazy(
  () => import("./pages/dashboard/workspace/propertypost/PropertyPost")
);
const AgentPropertyPost = lazy(
  () =>
    import("./pages/dashboard/workspace/agentPropertyPost/agentPropertyPost")
);
const WorkspaceAllActivities = lazy(
  () => import("./pages/dashboard/workspace/activities/WorkspaceAllActivities")
);
const CreateReviewPost = lazy(
  () => import("./pages/dashboard/workspace/reviewpost/CreateReviewPost")
);
const ScheduleAuctionList = lazy(
  () => import("./pages/dashboard/workspaceShedule/SceduleAuctionList")
);
const ScheduleOpenHomeList = lazy(
  () => import("./pages/dashboard/workspace/openhome/ScheduleOpenHomeList")
);
const OnBoardingPostList = lazy(
  () =>
    import("./pages/dashboard/workspace/onboardingpost/list/OnBoardingPostList")
);
const AgencyScheduleAuctionList = lazy(
  () =>
    import("./pages/dashboard/workspace/agencyAuctionPost/ScheduleAuctionList")
);
const AgencyScheduleOpenHomeList = lazy(
  () =>
    import(
      "./pages/dashboard/workspace/agencyopenhome/list/ScheduleOpenHomeList"
    )
);
const AgencyPropertyPostList = lazy(
  () =>
    import(
      "./pages/dashboard/workspace/agencyPropertyPost/list/PropertyPostList"
    )
);
const AgencyReviewPostList = lazy(
  () =>
    import("./pages/dashboard/workspace/agencyReviewPost/list/ReviewPostList")
);
const PropertyPostList = lazy(
  () => import("./pages/dashboard/workspace/propertypost/list/PropertyPostList")
);
const AgentPropertyPostList = lazy(
  () =>
    import(
      "./pages/dashboard/workspace/agentPropertyPost/list/PropertyPostList"
    )
);
const ReviewPostList = lazy(
  () => import("./pages/dashboard/workspace/reviewpost/list/ReviewPostList")
);
const ScheduleOpenHome = lazy(
  () => import("./pages/dashboard/workspace/openhome")
);
const WorkspaceSheduleConfigure = lazy(
  () =>
    import(
      "./pages/dashboard/WorkspaceSheduleConfigure/WorkspaceSheduleConfigure"
    )
);
const AgentPropertyPostView = lazy(
  () =>
    import(
      "./pages/dashboard/workspace/agentPropertyPost/view/PropertyPostView"
    )
);
const WorkspaceSchedule = lazy(
  () => import("./pages/dashboard/workspaceShedule/WorkspaceSchedule")
);
const CreateOnBoardingPost = lazy(
  () =>
    import("./pages/dashboard/workspace/onboardingpost/CreateOnBoardingPost")
);
const AgentRequestView = lazy(
  () => import("./pages/dashboard/agentJoiningRequests/view")
);
const AccountSettings = lazy(() => import("./pages/dashboard/accountSettings"));
const AgentJoiningRequests = lazy(
  () => import("./pages/dashboard/agentJoiningRequests/list")
);

const PropertieView = lazy(() => import("./pages/dashboard/properties/view"));
const OnboardingPostView = lazy(
  () =>
    import("./pages/dashboard/workspace/onboardingpost/view/OnboardingPostView")
);
const OpenHomeDetailView = lazy(
  () => import("./pages/dashboard/workspace/openhome/view/OpenHomeDetailView")
);
const AgencyOpenHomeDetailView = lazy(
  () =>
    import("./pages/dashboard/workspace/agencyopenhome/view/OpenHomeDetailView")
);
const AgencyPropertyPostView = lazy(
  () =>
    import(
      "./pages/dashboard/workspace/agencyPropertyPost/view/PropertyPostView"
    )
);
const AgencyScheduleAuctionView = lazy(
  () =>
    import(
      "./pages/dashboard/workspace/agencyAuctionPost/view/ScheduleAuctionView"
    )
);
const AgencyReviewPostView = lazy(
  () =>
    import("./pages/dashboard/workspace/agencyReviewPost/view/ReviewPostView")
);
const PropertyPostView = lazy(
  () => import("./pages/dashboard/workspace/propertypost/view/PropertyPostView")
);
const ReviewPostView = lazy(
  () => import("./pages/dashboard/workspace/reviewpost/view/ReviewPostView")
);
const ScheduleAuctionView = lazy(
  () => import("./pages/dashboard/workspaceShedule/view/ScheduleAuctionView")
);
const LoginVerifyEmail = lazy(
  () => import("./pages/agentSignIn/SignInVerifyEmail")
);
const HomeComponent = lazy(() => import("./pages/home/Home"));
const Register = lazy(() => import("./pages/agentRegister/Register"));
const SignIn = lazy(() => import("./pages/agentSignIn/SignIn"));
const RegiterVerifyEmail = lazy(
  () => import("./pages/agentRegister/RegisterVerifyEmail")
);
const AgentProfile = lazy(() => import("./pages/agentProfile/AgentProfile"));
const AgentVerifyPhone = lazy(
  () => import("./pages/agentProfile/AgentVerifyPhone")
);
const AgencyProfile = lazy(() => import("./pages/agencyProfile/AgencyProfile"));

const EditAndViewAgent = lazy(() => import("./pages/dashboard/agents/edit"));
const AgentsList = lazy(() => import("./pages/dashboard/agents"));
const CreateProperty = lazy(
  () => import("./pages/dashboard/properties/create")
);

const AgentProfileCreateAgencyProfile = lazy(
  () => import("./pages/agentProfile/AgentProfileCreateAgencyProfile")
);

const AgencyProfileAgentInfo = lazy(
  () => import("./pages/agencyProfile/AgencyProfileAgentInfo")
);

const AgencyProfileVerifyPhone = lazy(
  () => import("./pages/agencyProfile/AgencyProfileVerifyPhone")
);

const AgentAddAgencyInfo = lazy(
  () => import("./pages/agentProfile/AgentAddAgencyInfo")
);

const DesignTemplateTypes = lazy(
  () => import("./pages/dashboard/designTemplates/designTemplateTypes")
);
const DesignTemplateSubTypes = lazy(
  () => import("./pages/dashboard/designTemplates/designTemplateSubTypes")
);
const SavePaymentDetails = lazy(
  () => import("./pages/dashboard/test/SavePaymentDetails")
);
const AgencyApprovalWaiting = lazy(
  () => import("./pages/approvalWaiting/AgencyApprovalWaiting")
);

/**
 * TODO:
 *
 * Class for the recaptcha container
 * grecaptcha-badge
 *
 *
 */

const unprotectedRoutes = [
  clientRoutes.register,
  clientRoutes.login,
  clientRoutes.agencyApprovalWaiting,
  clientRoutes.agentVerifyEmail,
  clientRoutes.agencyVerifyEmail,
];

function App() {
  const navigate = useNavigate();
  const isUserLoggedIn = AuthHelpers.validateAccessToken();
  const location = useLocation();
  const pathname = location.pathname;
  let processRequest = true;

  let failedIterations = [];

  if (!isUserLoggedIn) {
    processRequest = false;

    for (let index = 0; index < unprotectedRoutes.length; index++) {
      const route = unprotectedRoutes[index] as string;

      if (!pathname?.includes(route)) {
        failedIterations.push(true);
      }
    }

    if (failedIterations.length !== unprotectedRoutes.length) {
      processRequest = true;
    }
  }

  if (!processRequest) navigate(clientRoutes.login);

  const getUserDetails = async (params: { user_type: string }) => {
    const { user_type } = params;

    if (user_type === CommonEnums.roles.agent) {
      const res = await AgentApi.GetAgentProfile();

      const success = res.success;
      const userData = res.data?.data;

      if (!success || !userData) navigate(clientRoutes.login);

      LocalStorageHelpers.setAgentData({
        data: userData,
      });
    }

    if (user_type === CommonEnums.roles.agency) {
      const res = await AgencyApi.getAgencyDetails();

      const success = res.success;
      const userData = res.data?.data;

      if (!success || !userData) navigate(clientRoutes.login);

      LocalStorageHelpers.setAgencyData({
        data: userData,
      });
    }
  };

  useEffect(() => {
    const sessionUserType = LocalStorageHelpers.getSessionUserType();

    if (
      pathname.includes("login") ||
      pathname.includes("registration-session") ||
      pathname.includes("agency-approval-waiting")
    )
      return;

    if (!sessionUserType) navigate(clientRoutes.login);
    if (!agentApproved()) navigate(clientRoutes.agencyApprovalWaiting);

    getUserDetails({
      user_type: sessionUserType as string,
    });

    const userProfileImages = document.querySelectorAll(".user-profile-image");

    userProfileImages.forEach((profileImage) => {
      profileImage.addEventListener("error", (event: any) => {
        event.src = "images/profile-placeholder-image.png";
      });
    });
  }, []);

  return (
    <div className="App">
      <Suspense fallback={<div></div>}>
        <Routes>
          <Route
            path={clientRoutes?.properties}
            element={
              <Suspense fallback={<div></div>}>
                <Properties />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.createProperties}
            element={
              <Suspense fallback={<div></div>}>
                <CreateProperty />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agentJoiningRequests}
            element={
              <Suspense fallback={<div></div>}>
                <AgentJoiningRequests />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agentRequestsView}
            element={
              <Suspense fallback={<div></div>}>
                <AgentRequestView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agents}
            element={
              <Suspense fallback={<div></div>}>
                <AgentsList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agentViewAndEdit}
            element={
              <Suspense fallback={<div></div>}>
                <EditAndViewAgent />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.manageInvites}
            element={
              <Suspense fallback={<div></div>}>
                <ManageInvitesList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.manageInvitesDetails}
            element={
              <Suspense fallback={<div></div>}>
                <InvitationDetails />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agentProfileView}
            element={
              <Suspense fallback={<div></div>}>
                <AgentProfileView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agencyProfileView}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyProfileView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.workspace}
            element={
              <Suspense fallback={<div></div>}>
                <Workspace />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.subscription}
            element={
              <Suspense fallback={<div></div>}>
                <Subscription />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.PropertyPost}
            element={
              <Suspense fallback={<div></div>}>
                <PropertyPost />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.allActivities}
            element={
              <Suspense fallback={<div></div>}>
                <WorkspaceAllActivities />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.agentPropertyPost}
            element={
              <Suspense fallback={<div></div>}>
                <AgentPropertyPost />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.scheduleOpenHome}
            element={
              <Suspense fallback={<div></div>}>
                <ScheduleOpenHome />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.WorkspaceCreatereviewPost}
            element={
              <Suspense fallback={<div></div>}>
                <CreateReviewPost />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.OnBoardingPost}
            element={
              <Suspense fallback={<div></div>}>
                <CreateOnBoardingPost />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AnnouncementPost}
            element={
              <Suspense fallback={<div></div>}>
                <CreateAnnouncementPost />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AgencyAnnouncementPost}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyCreateAnnouncementPost />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.FestivalPost}
            element={
              <Suspense fallback={<div></div>}>
                <CreateFestivalPost />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AgencyFestivalPost}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyCreateFestivalPost />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AgencyOnboardingPost}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyCreateOnBoardingPost />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.WorkspaceSchedule}
            element={
              <Suspense fallback={<div></div>}>
                <WorkspaceSchedule />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.WorkspaceScheduleList}
            element={
              <Suspense fallback={<div></div>}>
                <ScheduleAuctionList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.ScheduleOpenHomeList}
            element={
              <Suspense fallback={<div></div>}>
                <ScheduleOpenHomeList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AgencyOpenHomeList}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyScheduleOpenHomeList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AgencyPropertyPost}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyPropertyPostList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.OnBoardingPostList}
            element={
              <Suspense fallback={<div></div>}>
                <OnBoardingPostList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AgencyOnboardingPostList}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyOnboardingPostList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AnnouncementPostList}
            element={
              <Suspense fallback={<div></div>}>
                <AnnouncementPostList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AgencyAnnouncementPostList}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyAnnouncementPostList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.FestivalPostList}
            element={
              <Suspense fallback={<div></div>}>
                <FestivalPostList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AgencyFestivalPostList}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyFestivalPostList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AgencyReviewPost}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyReviewPostList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AgencyAuctionPost}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyScheduleAuctionList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.PropertyPostList}
            element={
              <Suspense fallback={<div></div>}>
                <PropertyPostList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AgentPropertyPostList}
            element={
              <Suspense fallback={<div></div>}>
                <AgentPropertyPostList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.ReviewPostList}
            element={
              <Suspense fallback={<div></div>}>
                <ReviewPostList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.WorkspaceSheduleConfigure}
            element={
              <Suspense fallback={<div></div>}>
                <WorkspaceSheduleConfigure />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.propertieView}
            element={
              <Suspense fallback={<div></div>}>
                <PropertieView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.scheduleOpenHomeView}
            element={
              <Suspense fallback={<div></div>}>
                <OpenHomeDetailView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AgencyScheduleOpenHomeView}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyOpenHomeDetailView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AgencyPropertyPostView}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyPropertyPostView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AgencyScheduleAuctionView}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyScheduleAuctionView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AgencyReviewPostView}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyReviewPostView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.PropertyPostView}
            element={
              <Suspense fallback={<div></div>}>
                <PropertyPostView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.CoAgentPropertyPostView}
            element={
              <Suspense fallback={<div></div>}>
                <CoAgentPropertyPostView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AgentPropertyPostView}
            element={
              <Suspense fallback={<div></div>}>
                <AgentPropertyPostView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.CoAgentPropertyView}
            element={
              <Suspense fallback={<div></div>}>
                <CoAgentPropertyView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.ReviewPostView}
            element={
              <Suspense fallback={<div></div>}>
                <ReviewPostView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.OnboardingPostView}
            element={
              <Suspense fallback={<div></div>}>
                <OnboardingPostView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AgencyOnboardingPostView}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyOnboardingPostView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AnnouncementPostView}
            element={
              <Suspense fallback={<div></div>}>
                <AnnouncementPostView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AgencyAnnouncementPostView}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyAnnouncementPostView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.FestivalPostView}
            element={
              <Suspense fallback={<div></div>}>
                <FestivalPostView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AgencyFestivalPostView}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyFestivalPostView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.ScheduleAuctionView}
            element={
              <Suspense fallback={<div></div>}>
                <ScheduleAuctionView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.propertieEdit}
            element={
              <Suspense fallback={<div></div>}>
                <PropertieEdit />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.register}
            element={
              <Suspense fallback={<div></div>}>
                <Register />
              </Suspense>
            }
          />
          <Route
            path={clientRoutes.login}
            element={
              <Suspense fallback={<div></div>}>
                <SignIn />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agentSignInVerifyEmail}
            element={
              <Suspense fallback={<div></div>}>
                <LoginVerifyEmail />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agencySignInVerifyEmail}
            element={
              <Suspense fallback={<div></div>}>
                <LoginVerifyEmail />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agentVerifyEmail}
            element={
              <Suspense fallback={<div></div>}>
                <RegiterVerifyEmail />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agentProfile}
            element={
              <Suspense fallback={<div></div>}>
                <AgentProfile />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agentVerifyPhone}
            element={
              <Suspense fallback={<div></div>}>
                <AgentVerifyPhone />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agentProfileAgencyInfo}
            element={
              <Suspense fallback={<div></div>}>
                <AgentAddAgencyInfo />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agentProfileCreateAgencyProfile}
            element={
              <Suspense fallback={<div></div>}>
                <AgentProfileCreateAgencyProfile />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agencyVerifyEmail}
            element={
              <Suspense fallback={<div></div>}>
                <RegiterVerifyEmail />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agencyProfileAgencyInfo}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyProfile />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agencyProfileVerifyPhone}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyProfileVerifyPhone />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agencyProfileAgentInfo}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyProfileAgentInfo />
              </Suspense>
            }
          />

          {/* <Route path={clientRoutes?.properties} element={<PropertieView />} /> */}
          <Route
            path={clientRoutes?.designTemplates}
            element={
              <Suspense fallback={<div></div>}>
                <DesignTemplateTypes />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.designTemplateTypes}
            element={
              <Suspense fallback={<div></div>}>
                <DesignTemplateSubTypes />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.designAnnoucementTemplateTypes}
            element={
              <Suspense fallback={<div></div>}>
                <AnnouncementTypes />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.designFestivalTemplateTypes}
            element={
              <Suspense fallback={<div></div>}>
                <FestivalTypes />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.home}
            element={
              <Suspense fallback={<div></div>}>
                <HomeComponent />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.testComponent}
            element={
              <Suspense fallback={<div></div>}>
                <SavePaymentDetails />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.agencyApprovalWaiting}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyApprovalWaiting />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.accountSettings}
            element={
              <Suspense fallback={<div></div>}>
                <AccountSettings />
              </Suspense>
            }
          />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
